/// <reference path="../../../../../../shared/utils/View.ts"/>
/// <reference path="../../../../../../shared/models/generated/MitgliedschaftAnlageResponseApi.d.ts"/>
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { ConfirmationPageController } from "./ConfirmationPageController";
import { BasicErrorService } from "../../../../../../shared/services/BasicErrorService";
import { AppApiService } from "../../services/AppApiService";
import { AppRateService } from '../../services/AppRateService';
import { BasicApplicationService } from "../../../../../../shared/services/BasicApplicationService";
import { User } from "../../../../../../shared/models/api/User/User";
import { LegalCommercialService } from '../../../../../../shared/services/LegalCommercialService';
import { AppModelAdapter } from '../../helper/AppModelAdapter';
import { BasicValidationService } from '../../../../../../shared/services/BasicValidationService';
import { CooperationService } from "../../../../../../shared/services/CooperationService";
import { ContractInfo } from '../../../../../../shared/models/api/User/ContractInfo';
import { ApplicationPages } from '../../Constants';
import { EcommerceProductStatus } from '../../../../../../shared/enums/EcommerceProductStatus';
import { EcommerceOrderStatus } from '../../../../../../shared/enums/EcommerceOrderStatus';
import { AppApplicationModel } from '../../models/AppApplicationModel';
import { AppUtils } from '../../../../../../shared/utils/index';

export class CheckPageController implements StepController {
	private readonly parent: AppController;
	private readonly options: MglAddMembersAppOptions;
	private readonly user: User;
	private readonly loader: BasicLoader<MglAddMembersAppDefinition>;
	private readonly applicationService: BasicApplicationService<MglAddMembersAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly appApiService: AppApiService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appRateService: AppRateService;
	private readonly errorService: BasicErrorService<MglAddMembersAppDefinition>;
	private readonly applicationRouter: BasicApplicationRouter<MglAddMembersAppDefinition>;
	private readonly cooperationService: CooperationService<MglAddMembersAppDefinition>;
	private validationService: BasicValidationService<MglAddMembersAppDefinition>;
	private readonly legalCommercialService: LegalCommercialService;
	private readonly $ctx: JQuery;

	constructor(parent: AppController, options: MglAddMembersAppOptions, loader: BasicLoader<MglAddMembersAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.user = user;
		this.loader = loader;
		this.$ctx = $(options.$ctx);
		this.applicationService = new BasicApplicationService(options);
		this.appViewService = new AppViewService(options, loader);
		this.appApiService = new AppApiService(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appRateService = new AppRateService(options, user);
		this.errorService = new BasicErrorService(options);
		this.applicationRouter = new BasicApplicationRouter(options);
		this.legalCommercialService = new LegalCommercialService(options);
		if (this.options.app.iscooperation) {
			this.cooperationService = new CooperationService(options);
		}
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};

			this.appViewService.render(viewConfig);
		} else {
			this.applicationRouter.back();
		}
	}

	/**
	 * User must be available and a member (if it is an plusupgrade the user has to be non-plus).
	 */
	private checkPreconditions(): boolean {
		const partnerAdvertisementData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
		if (this.options.app.isplusupgrade) {
			return !this.user.UserData.Mitgliedschaft.PlusMitglied && this.user.Valid && this.user.Member;
		} else if (this.options.app.ispartneradvertisement) {
			return undefined !== partnerAdvertisementData.productActiveOrderNumber && this.user.Valid && this.user.Member;
		}
		return this.user.Valid && this.user.Member;
	}

	/**
	 * returns view options for calculator page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const applicationModel = this.appPersistenceService.getApplicationModel();
		const partnerAdvertisingData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
		const cooperationModel = this.options.app.iscooperation ? this.cooperationService.getDynamicFieldsFromStore() : {};

		return {
			User: this.user,
			FormModel: applicationModel.FormModel,
			Antragssteller: AppModelAdapter.getAntragsstellerModel(this.user),
			Partner: applicationModel.FormModel.Partner,
			Kinder: applicationModel.FormModel.Kinder,
			IsConfirmationPage: false,
			PreventMemberEdit: true,
			isCheckPage: true,
			IsPartneradvertising: this.options.app.ispartneradvertisement,
			productActiveModel: partnerAdvertisingData.productActiveModel,
			hasCopayment: this.appPersistenceService.hasCopayment(),
			Tarif: applicationModel.ContractInfoModel,
			TarifBeschreibung: ContractInfo.getDescription(this.options.app.ratenamemappings, applicationModel.ContractInfoModel.TarifCodeId),
			IsPlusUpgrade: this.options.app.isplusupgrade,
			IsPremiumUpgrade: this.options.app.ispremiumupgrade,
			iscooperation: this.options.app.iscooperation !== undefined ? this.options.app.iscooperation : false,
			CooperationModel: cooperationModel,
			Bonus: applicationModel.FormModel.Bonus,
			HideBirthday: true
		};
	}

	public afterRenderApp(): void {
		T.Utils.Tracking.pushKameleoonData();
		this.validationService = new BasicValidationService({ options: this.options }, $(this.$ctx).find(`#${this.options.app.applicationId} form`));
		this.parent.afterRenderApp();
		this.appPersistenceService.setApplicationStepToStore(this.options.app.currenttemplate.step);
		this.legalCommercialService.checkAgeStage(this.user.UserData.Geburtsdatum);

		this.appViewService.checkCoPayment(
			this.appPersistenceService.getPartnerAdvertisingDataFromStorage()
		);
		this.appViewService.updateDiscountDebendentContent(this.user.UserData.Mitgliedschaft.InAusbildung || this.user.UserData.Mitgliedschaft.Schwerbehindert);
		this.appViewService.addCheckPageListeners(
			this.onViewChanged.bind(this),
			this.backLinkListener.bind(this),
			this.submitEnclosure.bind(this)
		);
		this.appRateService.updateRate();
		AppUtils.View.scrollTop();
	}

	private onViewChanged(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appPersistenceService.getFormModelFromStore();
			this.appViewService.updateLegalValues(formModel);
			formModel.WerbeZustimmungModel = this.appViewService.getWerbeZustimmungModel();
			this.appPersistenceService.setFormModelToStore(formModel);
		}, 'user-visible');
	}

	private backLinkListener(ev: Event): void {
		ev.preventDefault();
		const mglApp = this.appPersistenceService.getApplicationModel();
		mglApp.Step = 0;
		this.appPersistenceService.setApplicationModel(mglApp);
		location.reload();
	}

	private async pushEcommerceBasisPacket(appModel: AppApplicationModel): Promise<void> {
		let model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model = AppModelAdapter.updateEcommerceModel(model, appModel, this.options);

		model.productStatus = EcommerceProductStatus.CHECKOUT;
		model.checkOutStep = "2";

		await T.Utils.Tracking.setEcommerceModel(model);
		T.Utils.Tracking.push(model, T.Utils.Tracking.CHECKOUT, T.Utils.Tracking.PIWIK_ONLY);
	}

	private submitEnclosure(ev: Event): void {
		ev.preventDefault();
		if (this.validationService.isValid()) {
			const appModel = this.appPersistenceService.getApplicationModel();
			const advertisingData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
			this.pushEcommerceBasisPacket(appModel);
			const reqModel = AppModelAdapter.getAnlageApi(appModel.FormModel, this.user, advertisingData, this.options, false);
			AppUtils.View.startLoader();
			this.appApiService.submitEnclosure(reqModel, this.submitSuccess.bind(this), this.submitFailed.bind(this));
		}
	}

	private submitSuccess(successResponse: ApiResponse<AnlageResponseApi>): void {
		const model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model.productStatus = EcommerceProductStatus.ORDER;
		model.orderStatus = EcommerceOrderStatus.CONFIRMED;
		const userData = this.getTrackingUserData();
		T.Utils.Tracking.push(model, T.Utils.Tracking.ORDER, undefined, userData);

		if (this.options.app.iscooperation) {
			const successCallback = (): void => {
				this.showConfirmationPage(successResponse);
			};
			const errorCallback = (jqxhr: JQueryXHR): void => {
				this.errorService.handleError(jqxhr);
			};
			this.cooperationService.submitCooperationData(successCallback, errorCallback, AppModelAdapter.getIdentifyingPersonalData(this.user));
		} else {
			this.showConfirmationPage(successResponse);
		}
	}

	private getTrackingUserData(): { user_phone?: string; user_mail?: string } {
		const userData: { user_phone?: string; user_mail?: string } = {};
		const phonePrefix = this.user?.UserData?.Telefon?.Prefix;
		const phoneSuffix = this.user?.UserData?.Telefon?.Suffix;
		const email = this.user?.UserData?.Email;

		if (phonePrefix != null && phoneSuffix != null) {
			userData.user_phone = `${phonePrefix}${phoneSuffix}`;
		}

		if (email != null) {
			userData.user_mail = email;
		}

		return userData;
	}


	private showConfirmationPage(successResponse: ApiResponse<AnlageResponseApi>): void {
		const options = this.applicationService.preparePageOptions(ApplicationPages.Confirmation);
		const controller = new ConfirmationPageController(this.parent, options, this.user, this.loader, successResponse);
		controller.start();
	}

	private submitFailed(jqxhr: JQueryXHR): void {
		const model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model.productStatus = EcommerceProductStatus.ORDER;
		model.orderStatus = EcommerceOrderStatus.FORWARDED;
		const userData = this.getTrackingUserData();

		T.Utils.Tracking.push(model, T.Utils.Tracking.ORDER, undefined, userData);

		if (this.options.app.iscooperation && !this.errorService.isQualifiedError(jqxhr)) {
			this.cooperationService.submitCooperationData(() => {
				//dont care
			}, () => {
				//dont care
			}, AppModelAdapter.getIdentifyingPersonalData(this.user));
		}

		if (this.options.app.ispartneradvertisement && jqxhr.status === 400) {
			this.appViewService.showErrorDialog(this.validationService.getMappedBackendMessage(jqxhr.responseJSON.Messages[0].Id), this.onAdvertisingDenyClose.bind(this));
		} else if (jqxhr.status === 400) {
			this.errorService.handleError(jqxhr);
		} else {
			this.errorService.handleTechnicalErrorWithErrorTemplate(jqxhr, true);
			this.appPersistenceService.clearApplicationSession();
			if (this.options.app.iscooperation) {
				this.cooperationService.clearSession();
			}
		}
		T.Utils.View.stopLoader();
	}

	public onAdvertisingDenyClose(): void {
		this.applicationRouter.routeToLocation(this.options.app.partneradvertisingnotallowedurl);
	}

}
